import { useState, useRef } from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  LayoutAnimation,
  Platform,
  UIManager,
  Animated,
} from 'react-native';
import { CaretUp, CaretDown } from '../../sharedComponents/Icons';
import gs from '../../styles/globalStyles';
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';

if (Platform.OS === 'android' && UIManager.setLayoutAnimationEnabledExperimental) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}

const Accordion = ({ id, description, title }) => {
  const [expanded, setExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const animation = useRef(new Animated.Value(0)).current;

  const toggleExpand = () => {
    const finalValue = expanded ? 0 : contentHeight;

    Animated.timing(animation, {
      toValue: finalValue,
      duration: 300,
      useNativeDriver: false,
    }).start();

    setExpanded(prev => !prev);
  };

  return (
    <ThemedView bg='bg-surface-primary' key={id}>
      <ThemedPressable 
        flexDirection='row' 
        justifyContent='space-between' 
        alignItems='center' 
        backgroundColor='bg-surface-primary'  
        onPress={toggleExpand}
      >
        <ThemedView flex={1}>
          <ThemedText variant='b3s' color='text-primary'>{title}</ThemedText>
        </ThemedView>
        {expanded ? (
          <CaretUp size={14} color={themeColorSet['icon-primary']} weight="bold" />
        ) : (
          <CaretDown size={14} color={themeColorSet['icon-primary']} weight="bold" />
        )}
      </ThemedPressable>

      {/* Animated container */}
      <Animated.View style={{ height: animation, overflow: 'hidden' }}>
        <View
          onLayout={e => {
            if (contentHeight === 0) {
              setContentHeight(e.nativeEvent.layout.height);
              animation.setValue(expanded ? e.nativeEvent.layout.height : 0);
            }
          }}
        >
          <ThemedView mt='sm'>
            <ThemedText variant='b4r' color='text-secondary'>
              {description.replace('${tenure}', 12)}
            </ThemedText>
          </ThemedView>
        </View>
      </Animated.View>

      <ThemedView height={1} bg='border-secondary' marginVertical='lg' />
    </ThemedView>
  );
};

export default Accordion;
